import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {BeatLoader} from "react-spinners";

import CustomButton from "components/CustomButton";

import ButtonActionContainer from "./ButtonActionContainer";

import {black500} from "assets/jss/main";

import {fetch} from "utils/dataAccess";
import {downloadFileFromBlob} from "utils/createDownloadableFile";

LogButton.propTypes = {
    importReport: PropTypes.object.isRequired,
};

const DownloadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={black500}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         className="lucide lucide-download h-3 w-3 mr-1">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="7 10 12 15 17 10"></polyline>
        <line x1="12" x2="12" y1="15" y2="3"></line>
    </svg>
)

function LogButton({importReport}) {
    const [downloading, setDownloading] = useState(false);

    function handleDownloadErrors() {
        const reportId = importReport['@id'].replace('/import_reports/', '');
        setDownloading(true);

        fetch(`/import_reports/${reportId}/download_errors`)
            .then(response => response.json())
            .then(json => {
                const byteCharacters = atob(json.content);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'text/csv; charset=utf-8'});

                downloadFileFromBlob(json.fileName, blob);

            }).finally(() => setDownloading(false))
    }

    if (downloading) {
        return (
            <div style={{width: '50px', alignSelf: 'center'}}>
                <BeatLoader
                    sizeUnit={"px"}
                    size={4}
                    color={"#5e5b5b"}
                />
            </div>
        )
    }
    return (
        <CustomButton
            variant={'transparent'}
            color={'default'}
            noBorder
            onClick={(e) => {
                e.stopPropagation();
                handleDownloadErrors()
            }}
        >
            <ButtonActionContainer>
                <DownloadIcon /> Log
            </ButtonActionContainer>
        </CustomButton>
    );
}

export default LogButton;
